<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import ModelAgentSubscriptionPlan from '@/dc-it/models/ModelAgentSubscriptionPlan'

export default {
  name: 'AgentModelSubscriptionPlansView',
  components: { TableComponent },
  data() {
    return {
      model: ModelAgentSubscriptionPlan,
    }
  },
}
</script>

<style scoped>

</style>
